import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

import { Button } from "../../../../shared/ui/button/button";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Sidebar } from '../../../../core/services/sidebar';
import { CustomDropdown } from "../../../../shared/components/custom-dropdown/custom-dropdown";
import { CheckboxGroup } from "../../../../shared/ui/checkbox-group/checkbox-group";
import { annualRevenues, countries } from '../../../../shared/utils/data';
import { Modal } from '../../../../core/services/modal';
import { MultiSelectModal } from '../../../../shared/components/modals/multi-select-modal/multi-select-modal';

@Component({
  selector: 'app-step1-business-activity',
  imports: [Button, TranslatePipe, CommonModule, ReactiveFormsModule, CustomDropdown, CheckboxGroup],
  templateUrl: './step1-business-activity.html',
  styleUrl: './step1-business-activity.css'
})
export class Step1BusinessActivity {
  @Input() data: any;
  @Input() onboardingStep!: number;
  @Input() onboardingSubStep!: number;
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();

  typesOfExpectedTransactionOption = [
    { label: 'Cash management', value: 'cash' },
    { label: 'Money transfer', value: 'money' },
    { label: 'Bill payment', value: 'bill' },
    { label: 'Online purchases (e-Commerce)', value: 'online' },
    { label: 'Merchant Purchases (POS)', value: 'pos' },
    { label: 'ATM withdrawal/deposit', value: 'atm' },
    { label: 'Payroll processing', value: 'payroll' }
  ];

  purposeOfBusinessRelOptions = [
    { label: 'Corporate purchase' },
    { label: 'Marketing and Media services' },
    { label: 'Salary' },
    { label: 'Online shopping' },
    { label: 'Bill payments' },
    { label: 'Donations' },
  ];

  countryList = countries;

  totalExpectedTransactionOptions = annualRevenues;

  businessActivityForm = new FormGroup({

    purposeOfBusinessRelationship: new FormControl('', [Validators.required]),
    totalExpectedTransaction: new FormControl('', [Validators.required]),

    typesOfExpectedTransaction: new FormControl<string[]>([], [Validators.required]),
    multiNationalCompanies: new FormControl<any[]>([], [Validators.required]),
    expectedCountriesOfDealings: new FormControl<any[]>([], [Validators.required]),
  })

  constructor(private sidebarService: Sidebar, private modalService: Modal) {

  }

  ngOnInit(): void {
    this.sidebarService.setLinks([
      { label: 'SIDEBAR.PREVIOUS_SCREEN', action: () => this.goBackStep(), iconPath: 'assets/icons/arrow-blue.svg', variant: 'outlined' },
      { label: 'SIDEBAR.SAVE_EXIT', route: '/', iconPath: 'assets/icons/cancel-blue.svg', variant: 'plain' }
    ]);
  }


  onDropdownSelect(controlName: string, selectedItem: any) {
    this.businessActivityForm.get(controlName)?.setValue(selectedItem.label);
  }

  handleFormSubmission() {
    // console.log('Form submitted!', this.businessActivityForm.value);
    this.next.emit();
  }

  getControl(controlName: string): FormControl {
    return this.businessActivityForm.get(controlName) as FormControl;
  }

  addMultiNationalCompany() {
    const options: any = {
      title: 'BUSINESS_ACTIVITY.MULTINATIONAL_COMPANIES',
      subTitle: 'BUSINESS_ACTIVITY.PLEASE_SELECT_MULTIPLE_COUNTRIES',
      placeholder: 'BUSINESS_ACTIVITY.SEARCH_COUNTRY',
      showSearch: true,
      items: this.countryList,
      selectedValues: this.businessActivityForm.get('multiNationalCompanies')?.value,
      onConfirm: (selected: any[]) => {
        this.businessActivityForm.get('multiNationalCompanies')?.setValue(selected);
      },
    };

    this.modalService.open(MultiSelectModal, options);
  }

  addExpectedCountryDealings() {
    const options: any = {
      title: 'BUSINESS_ACTIVITY.EXPECTED_COUNTRIES_OF_DEALINGS',
      subTitle: 'BUSINESS_ACTIVITY.PLEASE_SELECT_MULTIPLE_COUNTRIES',
      placeholder: 'BUSINESS_ACTIVITY.SEARCH_COUNTRY',
      showSearch: true,
      items: this.countryList,
      selectedValues: this.businessActivityForm.get('expectedCountriesOfDealings')?.value,
      onConfirm: (selected: any[]) => {
        this.businessActivityForm.get('expectedCountriesOfDealings')?.setValue(selected);
      },
    };

    this.modalService.open(MultiSelectModal, options);
  }


  removeCountry(controlName: 'multiNationalCompanies' | 'expectedCountriesOfDealings', country: any) {
    const control = this.businessActivityForm.get(controlName) as FormControl<any[]>;
    const updated = control.value?.filter((c) => c.code !== country.code) || [];
    control.setValue(updated);
  }

  /** Go back to Company registration */
  goBackStep() {
    this.prev.emit();
  }
}


